define(
  'app/factories/yadisa_checkout',['app/setup', 'app/views/yadisa_checkout_wrap_option','app/views/yadis_checkout_gift_message',
  'app/views/yadisa_checkout_shipping_view'],
  function (takhfifan, YadisaCheckoutWrapOption, YadisaCheckoutGiftMessage, YadisaCheckoutShippingView) {
    $(function ($) {

      //gift message
      if ($('.thk-yadisa-co-gift-message').length > 0) {
        $('.thk-yadisa-co-gift-message').each(function () {
          new takhfifan.YadisaCheckoutGiftMessage({
            el: $(this)
          });
        });
      }

      //Wrap Option
      if ($('.tkh-yadisa-checkout-wrap').length > 0) {
        $('.tkh-yadisa-checkout-wrap').each(function () {
          new takhfifan.YadisaCheckoutWrapOption({
            el: $(this)
          });
        });
      }

      if ($('.tkh-yadisa-co-shipping').length > 0) {
        $('.tkh-yadisa-co-shipping').each(function () {
          new takhfifan.YadisaCheckoutShipping({
            el: $(this)
          });
        });
      }


    });
  });
